import React from 'react';
import { Download, Eye, Palette, Sliders, Zap } from 'lucide-react';

const APK_URL = "https://github.com/sanketpadhyal/Rivo-Agent-Application/releases/download/v3.0.0/rivo-agent-v3.apk";

const Hero = () => {
  return (
    <header className="hero-section">
      <div className="hero-container">
        <div className="hero-info">
          <h1 className="hero-title">
            Your Private, <br />
            <span className="gradient-text">On-Device AI</span>
          </h1>

          <p className="hero-subtitle">
            Rivo Agent v3.0.0 runs ultra-compact language & vision models directly on your smartphone. Chat offline, analyze images with SmolVLM, customize your theme, and experience private intelligence with zero cloud surveillance.
          </p>

          <div className="hero-actions">
            <a
              href={APK_URL}
              className="hero-primary-btn"
            >
              <Download size={20} strokeWidth={2.5} />
              <span>Download v3.0.0 APK</span>
            </a>
          </div>
          <p className="hero-support-note">Designed for all Android phones — requires as little as 1 GB RAM.</p>

          {/* v3.0.0 Feature Highlights */}
          <div className="v3-highlights-grid">
            <div className="v3-highlight-card">
              <div className="v3-icon-box vision-box">
                <Eye size={18} strokeWidth={2.2} />
              </div>
              <div className="v3-card-copy">
                <h4>Multimodal Vision AI</h4>
                <p>Instant image understanding & OCR using SmolVLM 256M (only 365 MB download, 1 GB RAM).</p>
              </div>
            </div>

            <div className="v3-highlight-card">
              <div className="v3-icon-box theme-box">
                <Palette size={18} strokeWidth={2.2} />
              </div>
              <div className="v3-card-copy">
                <h4>Appearance Customizer</h4>
                <p>Dynamic bubble & accent color swatches with tactile spring scaling animations.</p>
              </div>
            </div>

            <div className="v3-highlight-card">
              <div className="v3-icon-box drawer-box">
                <Zap size={18} strokeWidth={2.2} />
              </div>
              <div className="v3-card-copy">
                <h4>Fluid Slide Drawer</h4>
                <p>ChatGPT-style smooth 250ms side navigation with scale-down main chat workspace.</p>
              </div>
            </div>

            <div className="v3-highlight-card">
              <div className="v3-icon-box effort-box">
                <Sliders size={18} strokeWidth={2.2} />
              </div>
              <div className="v3-card-copy">
                <h4>Reasoning Effort Controls</h4>
                <p>Light, Medium, High, & Ultra effort presets with instant Fast Chat mode toggle.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
